<template>
	<div>
		<nav class="navbar bg-primary" :class="{ invert: invert, transparent }">
			<div style="width:52px">
				<div class="btn" v-ripple @click="opened = !opened" v-if="!back">
					<div class="icon icon-menu invert"></div>
				</div>
				<router-link tag="a" :to="back" class="btn" v-ripple v-if="back">
					<div class="icon icon-back invert"></div>
				</router-link>
			</div>

			<div class="flex-grow-1 d-flex align-items-center justify-content-center">
				<div v-if="title" class="pageTitle">{{ title }}</div>
				<div class="logo" v-if="!title"><img src="~@/assets/logo.png" /></div>
			</div>

			<div style="width:52px">
				<router-link tag="a" to="/profile" class="btn" v-ripple v-if="!back">
					<div class="icon icon-user invert"></div>
				</router-link>
			</div>
		</nav>
		<Sidebar :opened="opened" @closed="opened = false" />
	</div>
</template>

<script>
import Sidebar from './Sidebar'
import { mapGetters } from 'vuex'

export default {
	name: 'Navbar',
	components: {
		Sidebar,
	},
	props: ['title', 'back', 'invert', 'transparent'],
	data() {
		return {
			opened: false,
		}
	},
	computed: {
		...mapGetters(['loggedUser']),
	},
	methods: {},
}
</script>
<style scoped>
.navbar {
	height: 56px;
	display: flex;
	align-items: center;
	position: fixed;
	top: 0px;
	justify-content: space-between;
	left: 0px;
	right: 0px;
	color: #fff;
	padding: 0px;
	z-index: 100;
	/* background-color: #a50034; */
}

.navbar.transparent {
	background: transparent !important;
	/* background-size: cover; */
	/* background-image: url('~@/assets/img/bg-header.png'); */
}
.navbar:first-child,
.navbar:last-child {
	flex-shrink: 0;
}

.navbar .btn-menu-toggle {
	display: flex;
	align-items: center;
}
.navbar .btn-menu-toggle .icon {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	color: #fff;
}

.navbar .btn-back {
	display: flex;
	align-items: center;
}
.navbar .btn-back .icon {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	color: #fff;
}

.navbar .pageTitle {
	font-size: 16px;
	font-weight: 600;
}

.nav-spacer {
	width: 100%;
	height: 58px;
}

.logo img {
	width: 76px;
}

.navbar.invert {
	color: #000;
}
</style>
